// extracted by mini-css-extract-plugin
export default {"payment":"ky","title_row":"ly","border_bottom":"my","promo_wrapper":"ny","payment_wrapper":"oy","label":"py","card_row":"qy","cardcontain":"ry","card_input":"sy","card_error":"ty","card_label":"uy","lock":"vy","same_address":"wy","place_order_button":"xy","buttonwrap":"yy","hide_form":"zy","paypal_buttons":"Ay","review_button":"By","alt_payment":"Cy"};
    if(module.hot) {
      // 1714442369166
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  